@import '../../style/globals.scss';

.Icon {
    path {
        fill: var(--token-LEGACY-accent-theme-1-interface-interface-white);
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .spinner {
        animation: spin 1s linear infinite;
        transform-origin: center;
    }
}
